import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class VaultResPurchaseSample extends Component {
    getOrderId() {
        const { progLangId } = this.props;
        switch(progLangId) {
            case _DOTNET:
                return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
            case _JAVA:
                return `"Test"+createDate.getTime()`;
            case _PHP:
                return `'ord-'.date("dmy-G:i:s")`;
            default:
                return "";
        }
    }

    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    renderDOTNET() {
        const { storeId, apiToken} = this.props;
         return (
            <pre className="sampleCode">
{
`namespace Moneris
{
using System;
using System.Text;
using System.Collections;
public class TestCanadaResPurchaseCC {
public static void Main(string[] args)
{
string order_id = "${this.getOrderId()}";
string store_id = "`}{this.getValue(storeId, "storeId")}{`";
string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
string data_key = "eLqsADfwqHDxIpJG9vLnELx01";
string amount = "1.00";
string cust_id = "customer1"; //if sent will be submitted, otherwise cust_id from profile will be used
string crypt_type = "1";
string descriptor = "my descriptor";
string processing_country_code = "CA";
bool status_check = false;
CofInfo cof = new CofInfo();
cof.SetPaymentIndicator("U");
cof.SetPaymentInformation("2");
cof.SetIssuerId("12345678901234");
ResPurchaseCC resPurchaseCC = new ResPurchaseCC();
resPurchaseCC.SetDataKey(data_key);
resPurchaseCC.SetOrderId(order_id);
resPurchaseCC.SetCustId(cust_id);
resPurchaseCC.SetAmount(amount);
resPurchaseCC.SetCryptType(crypt_type);
resPurchaseCC.SetDynamicDescriptor(descriptor);
resPurchaseCC.SetCofInfo(cof);
//resPurchaseCC.SetExpDate("1511"); //optional - use for temp token only
HttpsPostRequest mpgReq = new HttpsPostRequest(); 
mpgReq.SetProcCountryCode(processing_country_code);
mpgReq.SetTestMode(true); //false or comment out this line for production transactions 
mpgReq.SetStoreId(store_id);
mpgReq.SetApiToken(api_token);
mpgReq.SetTransaction(resPurchaseCC);
mpgReq.SetStatusCheck(status_check);
mpgReq.Send();
try
{
Receipt receipt = mpgReq.GetReceipt();
Console.WriteLine("DataKey = " + receipt.GetDataKey());
Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
Console.WriteLine("ReferenceNum = " + receipt.GetReferenceNum()); 
Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
Console.WriteLine("AuthCode = " + receipt.GetAuthCode());
Console.WriteLine("Message = " + receipt.GetMessage()); 
Console.WriteLine("TransDate = " + receipt.GetTransDate()); 
Console.WriteLine("TransTime = " + receipt.GetTransTime()); 
Console.WriteLine("TransType = " + receipt.GetTransType()); 
Console.WriteLine("Complete = " + receipt.GetComplete()); 
Console.WriteLine("TransAmount = " + receipt.GetTransAmount()); 
Console.WriteLine("CardType = " + receipt.GetCardType()); 
Console.WriteLine("TxnNumber = " + receipt.GetTxnNumber()); 
Console.WriteLine("TimedOut = " + receipt.GetTimedOut()); 
Console.WriteLine("ResSuccess = " + receipt.GetResSuccess()); 
Console.WriteLine("PaymentType = " + receipt.GetPaymentType()); 
Console.WriteLine("IsVisaDebit = " + receipt.GetIsVisaDebit()); 
Console.WriteLine("IssuerId = " + receipt.GetIssuerId());
Console.WriteLine("Cust ID = " + receipt.GetResDataCustId()); 
Console.WriteLine("Phone = " + receipt.GetResDataPhone()); 
Console.WriteLine("Email = " + receipt.GetResDataEmail()); 
Console.WriteLine("Note = " + receipt.GetResDataNote()); 
Console.WriteLine("Masked Pan = " + receipt.GetResDataMaskedPan()); 
Console.WriteLine("Exp Date = " + receipt.GetResDataExpdate()); 
Console.WriteLine("Crypt Type = " + receipt.GetResDataCryptType()); 
Console.WriteLine("Avs Street Number = " + receipt.GetResDataAvsStreetNumber()); 
Console.WriteLine("Avs Street Name = " + receipt.GetResDataAvsStreetName()); 
Console.WriteLine("Avs Zipcode = " + receipt.GetResDataAvsZipcode()); 
Console.ReadLine();
}
catch (Exception e) { Console.WriteLine(e); }
}
}
}
`}
            </pre>
        )
    }

    renderJAVA() {
        const { storeId, apiToken } = this.props;
        return (
            <pre className="sampleCode">
{
`package Canada;
import JavaAPI.*;
public class TestCanadaResPurchaseCC
{
public static void main(String[] args)
{
java.util.Date createDate = new java.util.Date();
String order_id = "${this.getOrderId()}";
String store_id = "`}{this.getValue(storeId, "storeId")}{`";
String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
String data_key = "8OOXGiwxgvfbZngigVFeld9d2";
String amount = "1.00";
String cust_id = "customer1"; //if sent will be submitted, otherwise cust_id from profile will be used
String crypt_type = "1";
String descriptor = "my descriptor";
String processing_country_code = "CA";
String expdate = "1512"; //For Temp Token
boolean status_check = false;
ResPurchaseCC resPurchaseCC = new ResPurchaseCC();
resPurchaseCC.setData(data_key);
resPurchaseCC.setOrderId(order_id);
resPurchaseCC.setCustId(cust_id);
resPurchaseCC.setAmount(amount);
resPurchaseCC.setCryptType(crypt_type);
//resPurchaseCC.setDynamicDescriptor(descriptor);
//resPurchaseCC.setExpDate(expdate); //Temp Tokens only
//Mandatory - Credential on File details
CofInfo cof = new CofInfo();
cof.setPaymentIndicator("U");
cof.setPaymentInformation("2");
cof.setIssuerId("139X3130ASCXAS9");
resPurchaseCC.setCofInfo(cof);
HttpsPostRequest mpgReq = new HttpsPostRequest(); 
mpgReq.setProcCountryCode(processing_country_code);
mpgReq.setTestMode(true); //false or comment out this line for production transactions 
mpgReq.setStoreId(store_id);
mpgReq.setApiToken(api_token);
mpgReq.setTransaction(resPurchaseCC);
mpgReq.setStatusCheck(status_check); 
mpgReq.send();
try
{
Receipt receipt = mpgReq.getReceipt();
System.out.println("DataKey = " + receipt.getDataKey()); 
System.out.println("ReceiptId = " + receipt.getReceiptId()); 
System.out.println("ReferenceNum = " + receipt.getReferenceNum()); 
System.out.println("ResponseCode = " + receipt.getResponseCode()); 
System.out.println("AuthCode = " + receipt.getAuthCode()); 
System.out.println("Message = " + receipt.getMessage()); 
System.out.println("TransDate = " + receipt.getTransDate()); 
System.out.println("TransTime = " + receipt.getTransTime()); 
System.out.println("TransType = " + receipt.getTransType()); 
System.out.println("Complete = " + receipt.getComplete()); 
System.out.println("TransAmount = " + receipt.getTransAmount()); 
System.out.println("CardType = " + receipt.getCardType()); 
System.out.println("TxnNumber = " + receipt.getTxnNumber()); 
System.out.println("TimedOut = " + receipt.getTimedOut()); 
System.out.println("ResSuccess = " + receipt.getResSuccess()); 
System.out.println("PaymentType = " + receipt.getPaymentType()); 
System.out.println("IsVisaDebit = " + receipt.getIsVisaDebit()); 
System.out.println("Cust ID = " + receipt.getResCustId()); 
System.out.println("Phone = " + receipt.getResPhone()); 
System.out.println("Email = " + receipt.getResEmail()); 
System.out.println("Note = " + receipt.getResNote()); 
System.out.println("Masked Pan = " + receipt.getResMaskedPan()); 
System.out.println("Exp Date = " + receipt.getResExpdate()); 
System.out.println("Crypt Type = " + receipt.getResCryptType()); 
System.out.println("Avs Street Number = " + receipt.getResAvsStreetNumber()); 
System.out.println("Avs Street Name = " + receipt.getResAvsStreetName()); 
System.out.println("Avs Zipcode = " + receipt.getResAvsZipcode()); 
System.out.println("IssuerId = " + receipt.getIssuerId());
}
catch (Exception e)
{
e.printStackTrace();
}
}
}
`}
            </pre>
        )
    }

    renderPHP() {
        const { storeId, apiToken } = this.props;

        return (
            <pre className="sampleCode">
{
`<?php ##
## This program takes 3 arguments from the command line:
## 1. Store id
## 2. api token
## 3. order id ##
## Example php -q TestResPurchaseCC.php store3 yesguy unique_order_id 1.00
##
require "../../mpgClasses.php";
/************************ Request Variables **********************************/ 
$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token='`}{this.getValue(apiToken, "apiToken")}{`';
/************************ Transaction Variables ******************************/ 
$data_key='ot-odvn9lBTZm0lSWyQgansBqQi3';
$orderid='res-purch-'.date("dmy-G:i:s");
$amount='1.00';
$custid='cust';
$crypt_type='1';
$expdate='1911'; //For Temp Tokens only
/************************ Transaction Array **********************************/ 
$txnArray=array('type'=>'res_purchase_cc',
'data_key'=>$data_key,
'order_id'=>$orderid,
'cust_id'=>$custid,
'amount'=>$amount,
'crypt_type'=>$crypt_type,
//'expdate'=>$expdate,
'dynamic_descriptor'=>'12484'
);
/************************ Transaction Object *******************************/
$mpgTxn = new mpgTransaction($txnArray);
/******************* Credential on File **********************************/
$cof = new CofInfo();
$cof->setPaymentIndicator("U");
$cof->setPaymentInformation("2");
$cof->setIssuerId("12345678901234");
$mpgTxn->setCofInfo($cof);
/************************ Request Object **********************************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment 
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions 
/************************ mpgHttpsPost Object ******************************/
$mpgHttpPost =new mpgHttpsPost($store_id,$api_token,$mpgRequest);
/************************ Response Object **********************************/ 
$mpgResponse=$mpgHttpPost->getMpgResponse();
print("\\nDataKey = " . $mpgResponse->getDataKey());
print("\\nReceiptId = " . $mpgResponse->getReceiptId());
print("\\nReferenceNum = " . $mpgResponse->getReferenceNum());
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nISO = " . $mpgResponse->getISO());
print("\\nAuthCode = " . $mpgResponse->getAuthCode());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nTransDate = " . $mpgResponse->getTransDate());
print("\\nTransTime = " . $mpgResponse->getTransTime());
print("\\nTransType = " . $mpgResponse->getTransType());
print("\\nComplete = " . $mpgResponse->getComplete());
print("\\nTransAmount = " . $mpgResponse->getTransAmount());
print("\\nCardType = " . $mpgResponse->getCardType());
print("\\nTxnNumber = " . $mpgResponse->getTxnNumber());
print("\\nTimedOut = " . $mpgResponse->getTimedOut());
print("\\nAVSResponse = " . $mpgResponse->getAvsResultCode()); 
print("\\nResSuccess = " . $mpgResponse->getResSuccess()); 
print("\\nPaymentType = " . $mpgResponse->getPaymentType()); 
print("\\nIssuerId = " . $mpgResponse->getIssuerId());
//----------------- ResolveData ------------------------------ 
print("\\n\\nCust ID = " . $mpgResponse->getResDataCustId());
print("\\nPhone = " . $mpgResponse->getResDataPhone());
print("\\nEmail = " . $mpgResponse->getResDataEmail());
print("\\nNote = " . $mpgResponse->getResDataNote());
print("\\nMasked Pan = " . $mpgResponse->getResDataMaskedPan()); 
print("\\nExp Date = " . $mpgResponse->getResDataExpDate());
print("\\nCrypt Type = " . $mpgResponse->getResDataCryptType()); 
print("\\nAvs Street Number = " . $mpgResponse->getResDataAvsStreetNumber()); 
print("\\nAvs Street Name = " . $mpgResponse->getResDataAvsStreetName()); 
print("\\nAvs Zipcode = " . $mpgResponse->getResDataAvsZipcode());
?>
`}
            </pre>
        )
    }

    render() {
        switch(this.props.progLangId) {
            case _DOTNET: 
                return this.renderDOTNET()
            case _JAVA:
                return this.renderJAVA()
            case _PHP:
                return this.renderPHP()

            default:
                return null
        }
        
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { purchaseSuccess,purchaseResponse,loading } = state.vaultFinancial.main;
    const { storeId, apiToken, order_id, pan, expdate, onEditId} = state.vaultFinancial.main.config;
    return { mode, storeId, apiToken, order_id, pan, expdate, onEditId, loading, progLangId: state.common.progLangList.selection,purchaseSuccess,purchaseResponse };
  }
  
  export default connect(mapStateToProps, {})(VaultResPurchaseSample)